import m from 'mithril'

export default m.trust(`
  <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 2.5L3 4.5L7 1" stroke="black"/>
  </svg>
`)
